jQuery(document).ready(function($) {

  const swiperTechLogos = new Swiper('.swiper-tech', {
    spaceBetween: 46,
    speed: 3000,
    direction: 'horizontal',
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    },
    loop: true,
    slidesPerView: 1,
    freeMode: true,
    breakpoints: {
      320: {
        slidesPerView: 2,
      },
      568: {
        slidesPerView: 3,
      },
      720: {
        slidesPerView: 5,
      }
    }
  });

  /* Swiper Slider Cards Home - Show only on mobile */
  var swiper = new Swiper();
  var init = false;
  function swiperMode() {
    let mobile = window.matchMedia("(min-width: 0px) and (max-width: 720px)");

    if (mobile.matches) {
      if (!init) {
        $('.swiper-clients').addClass('swiper');
        $('.swiper-clients .logo-wrapper').addClass('swiper-wrapper');
        $('.swiper-clients .logo').addClass('swiper-slide');
        init = true;
        swiper = new Swiper('.swiper-clients', {
          spaceBetween: 46,
          speed: 3000,
          direction: 'horizontal',
          autoplay: {
            delay: 0,
            disableOnInteraction: false
          },
          loop: true,
          slidesPerView: 1,
          freeMode: true,
          breakpoints: {
            280: {
              slidesPerView: 2,
            },
            450: {
              slidesPerView: 3,
            },
            720: {
              slidesPerView: 5,
            }
          }
        });
      }
    } else {
      swiper.destroy();
      init = false;
      $('.swiper-clients').removeClass('swiper');
      $('.logo-wrapper').removeClass('swiper-wrapper');
      $('.logo').removeClass('swiper-slide');
    }
  }

  function swapVideo() {
    const video = $('.jrm-hero-video')[0];
    if(video){
      let mobileSize = window.matchMedia("(max-width: 768px)");
      if (mobileSize.matches) {
        video.src = video.getAttribute('data-mobile');
        
      } else {
        video.src = video.getAttribute('data-desktop');
      }
      video.load();
    }
  }

  window.addEventListener("load", function () {
    swiperMode();
    swapVideo();
  });

  window.addEventListener("resize", function () {
    swiperMode();
    swapVideo();
  });

  
  AOS.init();

  $(".page-template-template-jrmarine-ppc-landing-page a[href^='#']").on('click', function(e) {
    e.preventDefault();
    var targetElement = $(this.hash);
    
    if (targetElement.length && targetElement.offset()) {
      $('html, body').stop().animate({
        'scrollTop': targetElement.offset().top - 30
      }, 1000, 'linear');
      $('.jrm-hero-form').addClass('highlight');
    }
  });

});